import React from "react"

import SEO from "../components/seo"
import PMPLayout from "../components/index-components/pmp-layout"
import PMPHeader from "../components/index-components/pmp-header"
import CareersHero from "../components/careers/carrers-hero"
import CultureValuesSection from "../components/careers/culture-values"
import BenefitsSection from "../components/careers/benefits"
import OpenPositions from "../components/careers/open-positions"

export default ({ data }) => (
  <PMPLayout showNavigation>
    <SEO
      title="inPowered Careers - Join Silicon Valley's leading advertising AI startup"
      description="Join a team of risk-takers, dreamers, and leaders revolutionizing the advertising industry."
    />

    <PMPHeader />

    <CareersHero />

    <div className="container px-5 py-6 our-story-container">
      <h1 className="has-text-centered is-size-1 is-size-3-mobile has-text-weight-semibold has-text-centered-desktop has-text-purple mb-6">
        Our Values
      </h1>

      <div className="columns is-variable is-6 has-text-purple is-flex-gap-6">
        <div className="column container-subtitle is-12 has-text-weight-medium is-size-4-desktop has-text-centered">
          <p
            className="is-inline-block has-line-height-3"
            style={{
              maxWidth: "70ch",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            Our core values drive everything we do: from what we build and who
            we hire, to how we work with clients and measure success. We are
            creating a company we are proud of, one that has the power to change
            the advertising industry as we know it.
          </p>
        </div>
      </div>
    </div>
    <CultureValuesSection />
    <BenefitsSection />
    <OpenPositions id="open-roles" jobs={data.restApiJobs.data} />
  </PMPLayout>
)

export const pageQuery = graphql`
  query {
    restApiJobs {
      data {
        id
        title
        state
        description
        country_id
        city
      }
    }
  }
`
